import React from 'react'
import styled from 'styled-components'

const Quote = styled.blockquote`
    font-size: 1.2em;
    margin:50px auto;
    font-style:italic;
    color: #555555;
    padding:1.2em 30px 1.2em 75px;
    border-left:8px solid gray ;
    line-height:1.6;
    position: relative;
    background:#EDEDED;

    ::before {
        content: "\\201C";
        color:gray;
        font-size:4em;
        position: absolute;
        left: 10px;
        top:-10px;
    }

    ::after {
        content: '';
    }   
`

const SpanQuote = styled.span`
    display:block;
    color:#333333;
    font-style: normal;
    font-weight: bold;
    margin-top:1em;
`

const Quotes = (props) => {
    return (
        <div className="row row-cols-1 row-cols-md-2 justify-content-center">
            <div className="col mb-4">
                <Quote>
                    {props.quotes[0]}
                    <SpanQuote>
                        {props.quotes[1]}
                    </SpanQuote>
                </Quote>
            </div>
        </div>
    )
}

Quotes.defaultProps = {
    quotes: [
        "Anda Harus Bisa Keluar Dari Zona Nyaman Anda. Jadilah Miskin Untuk Sementara, Kehilangan Beberapa Teman, Kurangi Jam Tidur. Sebagian Orang Tak Paham Itu.",
        "Tupac Shakur",
    ],
}

export default Quotes